import src from "IMAGE";
export default { src, width: 161, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADk9SqQ4PEiYNThEjjc7R5k7P02iODxKlzs+TKUgIipRADw+REo9P0ZMR0pSZzw+REg6PEJCNzk+Ojs9Q0gtLjEhhf4SJ6J06V0AAAAASUVORK5CYII="};
